/** Organization datagrid key base — full key is `${EMPLOYEES_DATAGRID_KEY}_${organizationId}` */
export const EMPLOYEES_DATAGRID_KEY = "Employees_grid";

export const EMPLOYEE_PERSONALIZE_CONFIG = {
  defaultVisibleColumns: [
    "employee_code",
    "name",
    "department_name",
    "designation_name",
    "work_shift_name",
  ],
  columnLabels: {
    employee_code: "Emp Code",
    name: "Name",
    department_name: "Department",
    designation_name: "Designation",
    work_shift_name: "Work Shift",
    date_of_joining: "Date of Joining",
    employment_status_name: "Employment Status",
    employment_type_name: "Employment Type",
    gender: "Gender",
    location_name: "Location",
    work_model_name: "Work Model",
    age: "Age",
    working_since: "Working Since",
  },
  columnWidths: {
    employee_code: 150,
    name: 200,
    department_name: 180,
    designation_name: 180,
    work_shift_name: 200,
    date_of_joining: 140,
    employment_status_name: 150,
    employment_type_name: 150,
    gender: 100,
    location_name: 160,
    work_model_name: 140,
    age: 80,
    working_since: 180,
  },
};

/** Normalize saved/personalized column keys to match employee list API row keys. */
export function normalizeEmployeeColumnField(field) {
  const raw = String(field || "").trim();
  if (!raw) return raw;
  const lower = raw.toLowerCase();
  if (lower === "name" || lower === "full_name") return "name";
  if (lower === "department") return "department_name";
  if (lower === "designation") return "designation_name";
  if (lower === "location") return "location_name";
  if (lower === "work_shift") return "work_shift_name";
  if (lower === "work_model") return "work_model_name";
  if (lower === "employment_status") return "employment_status_name";
  if (lower === "employment_type") return "employment_type_name";
  if (lower === "employment_category") return "employment_category_name";
  if (lower === "employment_stage") return "employment_stage_name";
  return raw;
}

export function mapSavedEmployeeColumns(savedColumns = []) {
  const labelByField = Object.fromEntries(
    Object.entries(EMPLOYEE_PERSONALIZE_CONFIG.columnLabels || {})
  );

  return savedColumns
    .map((col) => {
      const field = normalizeEmployeeColumnField(col.field || col.key);
      if (!field || ["first_name", "middle_name", "last_name"].includes(field)) {
        return null;
      }
      return {
        ...col,
        field,
        key: field,
        label:
          col.label ||
          labelByField[field] ||
          field
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
        visible: col.visible !== false,
        filterable: col.filterable !== false,
        sortable: col.sortable !== false,
      };
    })
    .filter(Boolean);
}

export const EMPLOYEE_PERSONALIZE_COLUMN_KEYS = [
  "employee_code",
  "name",
  "department_name",
  "designation_name",
  "work_shift_name",
  "date_of_joining",
  "employment_status_name",
  "employment_type_name",
  "gender",
  "location_name",
  "work_model_name",
  "age",
  "working_since",
];
